import React, {useRef, useState} from "react";
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,
    BtnUndo,
    Editor,
    EditorProvider,
    HtmlButton,
    Separator,
    Toolbar
} from "react-simple-wysiwyg";
import {Button, TextField} from "@mui/material";
import {MergeFieldsDialog} from "../dialogs";
import {forms, objects} from "@atttomyx/shared-utils";
import "./templateForm.css";
import {sortingUtils} from "../../utils";

const TemplateForm = (props) => {
    const { submissionMergeFields, data, onChange : onSync } = props;
    const [ showMergeFields, setShowMergeFields] = useState(false);
    const wrapper = useRef(null);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.name && modified.content && sortingUtils.isSortable(modified.order);

        onSync(modified);
    };

    const insert = (liquid) => {
        if (wrapper.current && liquid) {
            const editor = wrapper.current.querySelector(".rsw-ce");

            if (editor) {
                editor.focus();
                document.execCommand('insertText', false, liquid);
            }
        }
    };

    return <div className="template-form">
        <div className="field top-margin">
            <TextField
                required={true}
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.name)}
                onChange={(event) => onChange("name", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Index"
                type="number"
                value={forms.sanitizeValue(data.order)}
                onChange={(event) => onChange("order", event.target.value)}
                inputProps={{
                    step: 1,
                    min: 0,
                }}
            />
        </div>
        <div className="field" ref={wrapper}>
            <EditorProvider>
                <Editor
                    value={forms.sanitizeValue(data.content)}
                    onChange={(event) => onChange("content", event.target.value)}
                >
                    {props.children || (
                        <Toolbar>
                            <BtnUndo/>
                            <BtnRedo/>
                            <Separator/>
                            <BtnBold/>
                            <BtnItalic/>
                            <BtnUnderline/>
                            <BtnStrikeThrough/>
                            <Separator/>
                            <BtnNumberedList/>
                            <BtnBulletList/>
                            <Separator/>
                            {/*<BtnLink />*/}
                            <BtnClearFormatting/>
                            <HtmlButton/>
                            <Separator/>
                            <BtnStyles/>
                            <Separator/>
                            <Button
                                className="merge-fields"
                                variant="text"
                                color="primary"
                                onClick={() => setShowMergeFields(true)}
                            >
                                Merge Fields
                            </Button>
                        </Toolbar>
                    )}
                </Editor>
            </EditorProvider>
        </div>
        {showMergeFields ?
            <MergeFieldsDialog
                submissionMergeFields={submissionMergeFields}
                onCancel={() => setShowMergeFields(false)}
                onInsert={(liquid) => {
                    insert(liquid);
                    setShowMergeFields(false)
                }}
            /> : null}
    </div>
}

export default TemplateForm;
